import React, { useState, useEffect, useContext } from "react";
// import * as React from "react";
import {
  TextField,
  IconButton,
  InputAdornment,
  Button,
  CircularProgress,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
 
import { loginPageContext } from "../../context";
import connectGenImage from '../../assets/connectGenImage.png';
import { endpoints } from "../../services/endpoints";
import { axiosInstanceLogin } from "../../services/axiosInstance";
import { handleEnterKey } from "../../preDefinedFunctions/inputFieldValidations";
 
import "./login.css";
 
const LOCK_DURATION = 30 * 1000;
const LOCK_KEY = "loginLockUntil";
 
const Login = () => {
  const [showPassword, setShowPassword] = React.useState(false);
  const [showForgotMessage, setShowForgotMessage] = React.useState(false);
  const [username, setUsername] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [error, setError] = React.useState('');
  const [failedAttempts, setFailedAttempts] = React.useState(0);
  const [isLocked, setIsLocked] = React.useState(false);
  const [unlockTime, setUnlockTime] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [snackbar, setSnackbar] = React.useState( {open: false});
  const passwordRef = React.useRef(null);
  const loginButtonRef = React.useRef(null);
 
  const navigate = useNavigate();
  const loginPageDetails = useContext(loginPageContext);
 
 
  const handleClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };
 
  // Check if locked on mount
  useEffect(() => {
    const storedUnlock = localStorage.getItem(LOCK_KEY);
    if (storedUnlock && Date.now() < parseInt(storedUnlock, 10)) {
      setIsLocked(true);
      setUnlockTime(parseInt(storedUnlock, 10));
    } else {
      localStorage.removeItem(LOCK_KEY);
    }
  }, []);
 
  // Auto-unlock when time is up
  useEffect(() => {
    if (isLocked && unlockTime) {
      const interval = setInterval(() => {
        if (Date.now() >= unlockTime) {
          setIsLocked(false);
          setFailedAttempts(0);
          setError('');
          
          localStorage.removeItem(LOCK_KEY);
          clearInterval(interval);
        }
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [isLocked, unlockTime]);
 
  const handleForgotPasswordClick = (e) => {
    e.preventDefault();
    setShowForgotMessage(true);
  };
 
  const handleLogin = async (e) => {
    e.preventDefault();
 
    if (!username || !password) {
      setError("Please fill in both username and password.");
      return;
    }
 
    if (isLocked) return;
 
    const payload = { username, password };
    setLoading(true);
 
    try {
      const response = await axiosInstanceLogin.post(endpoints.loginCred, payload);
      const { statusCode, body } = response.data;
 
      if (statusCode === 200) {
        setError('');
        setFailedAttempts(0);
        setIsLocked(false);
        localStorage.setItem("username", username);
        console.log("her01", username);
        localStorage.removeItem(LOCK_KEY);
        // loginPageDetails.setLoginPage(true);
        setLoading(false)
        navigate('/Genesys-Cloud-Credentials');
      } else {
        const attempts = failedAttempts + 1;
        setFailedAttempts(attempts);
 
        if (attempts >= 3) {
          const lockUntil = Date.now() + LOCK_DURATION;
          setIsLocked(true);
          setUnlockTime(lockUntil);
          localStorage.setItem(LOCK_KEY, lockUntil.toString());
          setError('Please reach out to <strong>contact@lightgoldenrodyellow-hare-546075.hostingersite.com</strong>. Try again after 30 Seconds.');
        } else {
          if(statusCode === 403){
            setError("Your login credentials expired, please reach out to <strong>contact@lightgoldenrodyellow-hare-546075.hostingersite.com</strong>")
          }
          else{
            setError("Invalid username or password");
          }
        }
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };
 
  return (
    <div className="login-container">
     
 
      <div className="login-main">
        <div className="login-right-container">
          <div className="login-center">
            <img src={connectGenImage} alt="ConnectGen" className="login-logo-img" />
            <h2>Welcome!</h2>
            <p>Please provide your details</p>
 
            <form>
              <TextField
                label="User Name"
                className="custom-input"
                type="text"
                variant="outlined"
                fullWidth
                margin="normal"
                onChange={(e) => setUsername(e.target.value)}
                onKeyDown={(e)=> handleEnterKey(e,passwordRef)}
                disabled={isLocked}
              />
 
              <TextField
              inputRef={passwordRef}
                label="Password"
                type={showPassword ? "text" : "password"}
                variant="outlined"
                fullWidth
                margin="normal"
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e)=> handleEnterKey(e, loginButtonRef)}
                disabled={isLocked}
                className="passwordDisableInEdge"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword((prev) => !prev)}
                        edge="end"
                        disabled={isLocked}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
 
              <div className="login-center-options">
                <a
                  href="#"
                  className="forgot-pass-link"
                  onClick={handleForgotPasswordClick}
                >
                  Forgot password?
                </a>
              </div>
 
              <div className="login-center-buttons">
                <Button
                ref={loginButtonRef}
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={handleLogin}
                  disabled={isLocked || loading}
                >
                  {loading ? (
                    <CircularProgress size={24} sx={{ color: "#fff" }} />
                  ) : isLocked ? (
                    "Locked"
                  ) : (
                    "Log In"
                  )}
                </Button>
 
                {error && (
                  <div
                    className="form-error"
                    dangerouslySetInnerHTML={{ __html: error }}
                  />
                )}
              </div>
            </form>
 
            {showForgotMessage && failedAttempts < 3 && (
              <div className="form-error">
                For password reset assistance, kindly reach out to our support team - <strong>support@lightgoldenrodyellow-hare-546075.hostingersite.com</strong>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
 
export default Login;